import React, { Component } from 'react';
import { connect } from "react-redux";
import { redirectToAnotherApplication } from "../../actions/crossSellApplicationActions";
import { getOfferPreFilledData } from "../../selectors";
import { updateStandardDataLayerAttributes, setPageNameSiteSection, setCustomDataLayer } from "../../analytics/adobe/index";
import { declineOfferDataLayer } from "../../analytics/adobe/dataLayerValues";
import { declinedStatusDataLayer } from "../../analytics/adobe/pendDataLayerValues";

class DeclineOffer extends Component{
  constructor(props) {
    super(props);
    this.state = { url: props.offerPreFilled.ssoReferrer, buttonShow: false };
  }
  componentWillMount() {
    if(this.props.offerPreFilled.journey === "JOURNEY_FROM_NORMAL_TO_PEND"){
      this.setState({ buttonShow: true });
    }
  }

  componentDidMount() {
    if(this.props.offerPreFilled.pendFlow){
      const { pageName, siteSection }=declinedStatusDataLayer;
      updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
    } else{
      const { pageName, siteSection, marketCode }=declineOfferDataLayer;
      updateStandardDataLayerAttributes(setCustomDataLayer(pageName, siteSection, marketCode), false);
    }
  }

  redirect=()=>{
    this.props.redirectURL(this.state.url);
  };

  render() {
    let button =(this.props.button !== false);
    if(this.state.buttonShow){
      button = true;
    }
    return (
      <div className="row">
        <div className="text-center col col-sm-7 col-md-7 col-lg-7 mx-auto">
          <p className="decline-offer-desc">
                 Sorry, but we’re unable to approve your application for a Barclays Personal Loan at this time.
          </p>
          <p>We'll send you a letter in the mail explaining our decision.</p>
          {button?<button className="bg-standard padding-12-50 top-padding-200-80 text-transform-inherit" onClick={this.redirect}>Go back</button>:null}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return { offerPreFilled: getOfferPreFilledData(state) };
};
const mapDispatchToProps={ redirectURL: redirectToAnotherApplication };

export default connect(mapStateToProps, mapDispatchToProps)(DeclineOffer);


